export type MobilePlatform = "android" | "ios";

export function detectMobilePlatform(navigatorRef?: Navigator): MobilePlatform | null {
  const currentNavigator = navigatorRef || (typeof navigator !== "undefined" ? navigator : null);
  if (!currentNavigator) {
    return null;
  }

  const userAgent = currentNavigator.userAgent || "";
  const platform = currentNavigator.platform || "";
  const iPadDesktopMode = platform === "MacIntel" && currentNavigator.maxTouchPoints > 1;

  if (/Android/i.test(userAgent)) {
    return "android";
  }

  if (/iPhone|iPad|iPod/i.test(userAgent) || /iPhone|iPad|iPod/i.test(platform) || iPadDesktopMode) {
    return "ios";
  }

  return null;
}
